var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-container"},[_c('a-table',{attrs:{"pagination":_vm.showPagination,"columns":_vm.tableColumns,"dataSource":_vm.tableDataList,"rowSelection":_vm.rowSelection,"scroll":{ x: 750, y: 450 }}}),_c('a-button',{style:({
      width: '200px',
      height: '40px',
      margin: '15px 10px 0px'
    }),attrs:{"type":"dashed"},on:{"click":function($event){$event.stopPropagation();return _vm.closeWin($event)}}},[_vm._v(" 取 消 ")]),_c('a-button',{style:({
      width: '200px',
      height: '40px',
      margin: '15px 10px 0px'
    }),attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.bindArea($event)}}},[_vm._v(" 绑 定 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }